// Set cerrado de reacciones del hilo. Es una decisión de UI: la tabla
// message_reactions guarda el emoji como texto Unicode, así que ampliar este
// set (o añadir un picker) en el futuro no requiere migración de datos.
//
// Orden = orden en que se muestran en la barra bajo cada mensaje.
export const REACTION_EMOJIS = ['👍', '✅', '❤️', '👀', '👎'] as const;

export type ReactionEmoji = (typeof REACTION_EMOJIS)[number];
